import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import CartInfo from 'bento-ordering/cart/components/CartInfo';
import CartItemsList from 'bento-ordering/cart/components/CartItemsList';
import CartFulfillment from 'bento-ordering/cart/components/CartFulfillment';
import { isMobileMedia } from 'bento-ordering/utils/media';
import { getFormattedDollarDifference } from 'bento-ordering/base/utils/formattedDollar';
import CloseButton from 'bento-ordering/base/ui_components/CloseButton';
import Rule from 'bento-ordering/base/ui_components/Rule';
import CartHeader from 'bento-ordering/cart/components/CartHeader';
import FeatureFlag from 'bento-ordering/base/components/FeatureFlag';
import { ENABLE_DELIVERY } from 'bento-ordering/base/constants/flags';
import OutlinedBoxError from 'bento-ordering/base/ui_components/OutlinedBoxError';
import CartPageCheckoutContainer from 'bento-ordering/cart/containers/CartPageCheckoutContainer';

class Cart extends React.Component {
  static propTypes = {
    items: PropTypes.array,
    clearCart: PropTypes.func,
    getEditCartItemPath: PropTypes.func,
    removeItemFromCart: PropTypes.func,
    fulfillmentMethod: PropTypes.string,
    currentPrepTime: PropTypes.string,

    // this will need to be an object eventually
    // to get the location name
    restaurantName: PropTypes.string,
    // to do: make sure this corresponds to fulfillment date time
    requested_fulfillment_is_asap: PropTypes.bool,
    total: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    tax: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    subtotal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    fulfillment_date: PropTypes.string,
    fulfillment_time: PropTypes.string,
    handleClose: PropTypes.func,
    handleEditClick: PropTypes.func,
    currentCartPath: PropTypes.string,
    changeFulfillment: PropTypes.func,
    isTotalBelowMinimum: PropTypes.bool,
    orderMinimum: PropTypes.number,
    online_ordering_service_fee: PropTypes.string,
    taxes_and_fees: PropTypes.string,
    fulfillmentTimeOrASAP: PropTypes.string,
    shipping_street_address_1: PropTypes.string,
    deliveryFee: PropTypes.string,
    customFee: PropTypes.string,
    customFeeName: PropTypes.string,
    bundleServiceFeeWithCustomFee: PropTypes.bool,
    bundledServiceAndCustomFees: PropTypes.string,
    cartValidationError: PropTypes.string
  };

  handleClick = () => {
    this.props.handleClose();
  };

  getTaxesLabel = () => {
    return this.props.taxes_and_fees ? `Tax & Fees` : `Tax`;
  };

  render() {
    const {
      items,
      total,
      subtotal,
      fulfillmentMethod,
      restaurantName,
      requested_fulfillment_is_asap,
      fulfillment_date,
      fulfillment_time,
      currentPrepTime,
      clearCart,
      getEditCartItemPath,
      removeItemFromCart,
      handleEditClick,
      currentCartPath,
      changeFulfillment,
      isTotalBelowMinimum,
      orderMinimum,
      tax,
      online_ordering_service_fee,
      taxes_and_fees,
      fulfillmentTimeOrASAP,
      shipping_street_address_1,
      deliveryFee,
      customFee,
      customFeeName,
      bundleServiceFeeWithCustomFee,
      bundledServiceAndCustomFees,
      cartValidationError
    } = this.props;

    const amountFromMinimum = getFormattedDollarDifference(
      orderMinimum,
      subtotal
    );

    return (
      <div id="cart">
        <CloseButton autoFocus handleClick={this.handleClick} />
        <FeatureFlag
          flag={ENABLE_DELIVERY}
          renderComponent={
            <CartHeader
              fulfillmentMethod={fulfillmentMethod}
              onClick={changeFulfillment}
            />
          }
          fallbackComponent={
            <Box mb={2}>
              <Typography variant="h2">Your Cart</Typography>
            </Box>
          }
        />
        <CartFulfillment
          fulfillmentMethod={fulfillmentMethod}
          currentPrepTime={currentPrepTime}
          restaurantName={restaurantName}
          fulfillmentDate={fulfillment_date}
          fulfillmentTime={fulfillment_time}
          fulfillmentAddress={shipping_street_address_1}
          requestedFulfillmentIsAsap={requested_fulfillment_is_asap}
          changeFulfillment={changeFulfillment}
          fulfillmentTimeOrASAP={fulfillmentTimeOrASAP}
        />
        <Box position="relative">
          <Rule />
        </Box>
        <CartItemsList
          data={items}
          getEditCartItemPath={getEditCartItemPath}
          removeItemFromCart={removeItemFromCart}
          handleClose={handleEditClick}
          currentCartPath={currentCartPath}
        />
        <CartInfo
          total={total}
          tax={tax}
          serviceFee={online_ordering_service_fee}
          subtotal={subtotal}
          clearCart={clearCart}
          taxFieldLabel={this.getTaxesLabel()}
          taxesAndFees={taxes_and_fees}
          deliveryFee={deliveryFee}
          customFee={customFee}
          customFeeName={customFeeName}
          bundleServiceFeeWithCustomFee={bundleServiceFeeWithCustomFee}
          bundledServiceAndCustomFees={bundledServiceAndCustomFees}
          fulfillmentMethod={fulfillmentMethod}
        />
        {isTotalBelowMinimum && (
          <Box mb={2.5}>
            <Typography variant="caption">
              {`Add $${amountFromMinimum} to reach the minimum of $${orderMinimum}.`}
            </Typography>
          </Box>
        )}

        {!isMobileMedia() && (
          <Box mt="1.5rem">
            <CartPageCheckoutContainer />
          </Box>
        )}

        {cartValidationError && (
          <Box data-testid="cart-item-inventory-error" mt={2.5}>
            <OutlinedBoxError>{cartValidationError}</OutlinedBoxError>
          </Box>
        )}
      </div>
    );
  }
}

export default Cart;
